var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "#52DD91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73047 17.7812C10.0039 18.0547 10.4688 18.0547 10.7422 17.7812L18.7812 9.74219C19.0547 9.46875 19.0547 9.00391 18.7812 8.73047L17.7969 7.74609C17.5234 7.47266 17.0859 7.47266 16.8125 7.74609L10.25 14.3086L7.16016 11.2461C6.88672 10.9727 6.44922 10.9727 6.17578 11.2461L5.19141 12.2305C4.91797 12.5039 4.91797 12.9688 5.19141 13.2422L9.73047 17.7812Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectSolid);
export default __webpack_public_path__ + "static/media/correct-solid.9bd5b04e0f81503a84eca28e110c1a97.svg";
export { ForwardRef as ReactComponent };